var _path, _path2, _g, _path3, _g2, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJoinOperator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9833_5603)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9833_5603",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H0V15H16V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9833_5603)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9833_5603",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 15
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H0V15H16V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9833_5603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.95233 0.138612L12.7191 2.87516C13.0422 3.04872 13.2446 3.37886 13.2487 3.73907V9.74499C13.2435 10.1049 13.0415 10.4345 12.7191 10.6089L5.12407 14.9646C5.00116 15.0357 4.84257 14.9964 4.76921 14.8767C4.7465 14.8389 4.73375 14.7963 4.73213 14.7525V12.1091L2.12632 10.6089C1.80393 10.4345 1.60184 10.1049 1.59668 9.74499V3.73907C1.60073 3.37886 1.80314 3.04872 2.12632 2.87516L6.89305 0.138612C7.2208 -0.046204 7.62459 -0.046204 7.95233 0.138612Z",
    fill: "url(#paint0_linear_9833_5603)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3.004C11.481 3.03585 10.9917 3.25636 10.624 3.62401C10.2564 3.99165 10.0358 4.48105 10.004 5H9.996C9.96421 4.48103 9.74371 3.9916 9.37605 3.62395C9.0084 3.25629 8.51897 3.03579 8 3.004V2.996C8.51897 2.96421 9.0084 2.74371 9.37605 2.37605C9.74371 2.0084 9.96421 1.51897 9.996 1H10.004C10.0358 1.51895 10.2564 2.00835 10.624 2.37599C10.9917 2.74364 11.481 2.96415 12 2.996V3.004Z",
    fill: "url(#paint1_radial_9833_5603)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_9833_5603",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 15
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H0V15H16V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_9833_5603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.95233 0.138612L12.7191 2.87516C13.0422 3.04872 13.2446 3.37886 13.2487 3.73907V9.74499C13.2435 10.1049 13.0415 10.4345 12.7191 10.6089L5.12407 14.9646C5.00116 15.0357 4.84257 14.9964 4.76921 14.8767C4.7465 14.8389 4.73375 14.7963 4.73213 14.7525V12.1091L2.12632 10.6089C1.80393 10.4345 1.60184 10.1049 1.59668 9.74499V3.73907C1.60073 3.37886 1.80314 3.04872 2.12632 2.87516L6.89305 0.138612C7.2208 -0.046204 7.62459 -0.046204 7.95233 0.138612Z",
    fill: "url(#paint2_linear_9833_5603)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3.004C11.481 3.03585 10.9917 3.25636 10.624 3.62401C10.2564 3.99165 10.0358 4.48105 10.004 5H9.996C9.96421 4.48103 9.74371 3.9916 9.37605 3.62395C9.0084 3.25629 8.51897 3.03579 8 3.004V2.996C8.51897 2.96421 9.0084 2.74371 9.37605 2.37605C9.74371 2.0084 9.96421 1.51897 9.996 1H10.004C10.0358 1.51895 10.2564 2.00835 10.624 2.37599C10.9917 2.74364 11.481 2.96415 12 2.996V3.004Z",
    fill: "url(#paint3_radial_9833_5603)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.05928 11H5.41991C5.30854 11 5.20175 10.9506 5.123 10.8627C5.04425 10.7747 5 10.6555 5 10.5312V6.46875C5 6.34441 5.04425 6.22521 5.123 6.13729C5.20175 6.04937 5.30854 6 5.41991 6H9.05928C9.17066 6 9.27749 6.04937 9.35624 6.13729C9.43499 6.22521 9.47924 6.34441 9.47924 6.46875V6.96562C9.47924 7.08995 9.43499 7.20916 9.35624 7.29707C9.27749 7.38499 9.17066 7.43436 9.05928 7.43436C8.94795 7.43436 8.84112 7.38499 8.76237 7.29707C8.68362 7.20916 8.63937 7.08995 8.63937 6.96562V6.93749H5.83986V10.0625H8.63937V10.0343C8.63937 9.91001 8.68362 9.7908 8.76237 9.70288C8.84112 9.61497 8.94795 9.56559 9.05928 9.56559C9.17066 9.56559 9.27749 9.61497 9.35624 9.70288C9.43499 9.7908 9.47924 9.91001 9.47924 10.0343V10.5312C9.47924 10.6555 9.43499 10.7747 9.35624 10.8627C9.27749 10.9506 9.17066 11 9.05928 11Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5803 11.0001H10.9409C10.8295 11.0001 10.7227 10.9507 10.644 10.8628C10.5652 10.7749 10.521 10.6557 10.521 10.5314V10.0345C10.521 9.91013 10.5652 9.79092 10.644 9.70301C10.7227 9.61509 10.8295 9.56572 10.9409 9.56572C11.0523 9.56572 11.1591 9.61509 11.2379 9.70301C11.3166 9.79092 11.3609 9.91013 11.3609 10.0345V10.0626H14.1604V6.93762H11.3609V6.96574C11.3609 7.09007 11.3166 7.20928 11.2379 7.2972C11.1591 7.38511 11.0523 7.43449 10.9409 7.43449C10.8295 7.43449 10.7227 7.38511 10.644 7.2972C10.5652 7.20928 10.521 7.09007 10.521 6.96574V6.47045C10.521 6.34612 10.5652 6.22687 10.644 6.139C10.7227 6.05108 10.8295 6.00171 10.9409 6.00171H14.5803C14.6917 6.00171 14.7985 6.05108 14.8772 6.139C14.956 6.22687 15.0002 6.34612 15.0002 6.47045V10.533C14.9999 10.657 14.9554 10.7758 14.8767 10.8634C14.798 10.951 14.6914 11.0001 14.5803 11.0001Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0982 8.97045H7.89892C7.78758 8.97045 7.68075 8.92103 7.602 8.83316C7.52325 8.74524 7.479 8.62599 7.479 8.5017C7.479 8.37737 7.52325 8.25812 7.602 8.17025C7.68075 8.08233 7.78758 8.03296 7.89892 8.03296H12.0982C12.2096 8.03296 12.3164 8.08233 12.3952 8.17025C12.4739 8.25812 12.5181 8.37737 12.5181 8.5017C12.5181 8.62599 12.4739 8.74524 12.3952 8.83316C12.3164 8.92103 12.2096 8.97045 12.0982 8.97045Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9833_5603",
    x1: 4.69857,
    y1: 2.88773,
    x2: 13.5,
    y2: 12.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#645EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3BF5D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_9833_5603",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.397 2.62575) rotate(23.8875) scale(3.3937 27.1856)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#A9A2A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#B8B8B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9833_5603",
    x1: 4.69857,
    y1: 2.88773,
    x2: 13.5,
    y2: 12.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#665DFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E274D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_9833_5603",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.397 2.62575) rotate(23.8875) scale(3.3937 27.1856)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#A9A2A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#B8B8B8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9833_5603"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoinOperator);
export default __webpack_public_path__ + "static/media/Join-Operator.07c27014920ceff1c65b6bc864010182.svg";
export { ForwardRef as ReactComponent };